module.exports = __webpack_public_path__ + "img/gr.0bed56a8.svg";